import { field, relation ,text} from '@nozbe/watermelondb/decorators';
import { CUSTOMER_ACCOUNTS_SCHEMA } from '../schema';
import { Model } from '@nozbe/watermelondb';

export default class CustomerAccounts extends Model {
    static table = CUSTOMER_ACCOUNTS_SCHEMA;

    static associations = {
        customer: { type: 'belongs_to', key: 'customer_id' }
    }

    @text('account_number') account_number;
    @text('title') title;
    @text('bank') bank;
    @text('type') type;

    @relation('customer', 'customer_id') customer;
};